module.exports = __webpack_public_path__ + "img/logo_1.fb32f508.png";